import { ref, watch, onMounted } from "@vue/composition-api";
import ChartDataService from "../../services/ChartDataService";

export default function useDotplotChartMean(configRef, availableWidthRef, availableHeightRef, xRef, yRef, xBandwidthRef) {
  const means = ref([]);

  //////////////////////////////////////////////////////////////////////////////////
  //                          TEMPORARY SOLUTION                                  //
  //////////////////////////////////////////////////////////////////////////////////
  const ds = new ChartDataService();

  const updateMean = () => {
    if (!configRef?.value || !xRef?.value || !yRef?.value) {
      means.value = [];
      return;
    }

    const halfXBandwidth = xBandwidthRef.value / 2;

    const data = ds.__temp__getMedianForTrial(configRef.value.trial, configRef.value.id);

    const newMeans = data.map((d) => ({
      x1: xRef.value(d.x) + halfXBandwidth - 15,
      y1: yRef.value(d.y),
      x2: xRef.value(d.x) + halfXBandwidth + 15,
      y2: yRef.value(d.y),
      color: "#006D8A",
      strokeWidth: 1.5,
    }));

    means.value = newMeans;
  };

  watch([configRef, availableWidthRef, availableHeightRef, xRef, yRef, xBandwidthRef], updateMean);

  onMounted(updateMean);

  return { means };
}
